import { useEffect } from 'react';

const KEY = 'aethex_appearance';

export const DEFAULTS = {
  theme:    'dark',    // dark | light | amoled
  fontSize: 14,        // 12 | 14 | 16
  density:  'cozy',   // cozy | compact
  streamer: false,
  reducedMotion: false,
  saturation: 100,    // 60-130
};

export function loadAppearance() {
  try { return { ...DEFAULTS, ...JSON.parse(localStorage.getItem(KEY) || '{}') }; } catch { return DEFAULTS; }
}

export function saveAppearance(prefs) {
  localStorage.setItem(KEY, JSON.stringify(prefs));
  applyAppearance(prefs);
}

export function applyAppearance(prefs = loadAppearance()) {
  const root = document.documentElement;

  // Theme
  root.setAttribute('data-theme', prefs.theme || 'dark');

  // Font size
  root.style.setProperty('--chat-font-size', `${prefs.fontSize || 14}px`);

  // Density
  root.setAttribute('data-density', prefs.density || 'cozy');

  // Streamer mode
  root.setAttribute('data-streamer', prefs.streamer ? 'on' : 'off');

  // Saturation
  root.style.filter = prefs.saturation !== 100 ? `saturate(${prefs.saturation / 100})` : '';

  // Reduced motion
  if (prefs.reducedMotion) {
    root.style.setProperty('--transition-speed', '0ms');
  } else {
    root.style.removeProperty('--transition-speed');
  }
}

export function useAppearance() {
  useEffect(() => {
    applyAppearance(loadAppearance());
  }, []);
}
